export const NEW_CHAT = 'NEW_CHAT';
export const FACTORY_OPERATOR_USER_ID = 'Factory Operator';
export const FACTORY_OPERATOR_THINKING_MESSAGE = 'FACTORY_OPERATOR_THINKING';
